import { useTheme } from "../../../../context/useThemeContext";
import useMainStore from "../../../../stores/mainStore";
import useDataStore from "../../../../stores/dataStore";

function SelectionIndicator(props: {
    id?: string;
    numOpenedNotesInFolder: number;
}) {
    const { theme } = useTheme();

    // State
    const selectedNoteID = useMainStore((state) => state.data.selectedNoteID);
    const selectedNoteFolderID = useDataStore(
        (state) => state.data.notes[selectedNoteID]?.folderID
    );

    // Store
    const folderColor = useDataStore((state) =>
        props.id
            ? theme.accentColors[state.data.folders[props.id]?.color]
            : theme.fontColor[100]
    );

    // Set the selection indicator opacity if folder has current opened tab
    function getSelectedIndicatorOpacity() {
        if (!selectedNoteID) {
            return 0;
        } else if (selectedNoteFolderID === props.id) {
            return 1;
        } else if (props.numOpenedNotesInFolder > 0) {
            return 0;
        } else {
            return 0;
        }
    }

    return (
        <>
            {/* Shows if currently selected note is in this folder */}
            <div
                className="folderSelection w-[4px] h-[44px] absolute left-[0px] rounded"
                style={{
                    backgroundColor: folderColor,
                    opacity: getSelectedIndicatorOpacity(),
                }}
            />
        </>
    );
}

export default SelectionIndicator;
